import { FieldProps } from 'formik';
import { get } from 'lodash';
import * as React from 'react';
import { ChangeEvent } from 'react';
import { InputBox } from '..';

interface IOwnProps {
  id: string;
  label: string;
  name: string;
  semanticType: string;
  variant?: 'tick' | 'toggle';
  checked: boolean;
  value: string | boolean;
  onChange: (event: ChangeEvent<any>) => void;
}

const InputBoxField: React.SFC<FieldProps<any> & IOwnProps> = ({
  field: { name, value: fieldValue, onChange, onBlur },
  form: { touched, errors }, // also values, setFieldValue, setXXXX, handleXXXX, dirty, isValid, status, etc.
  id, semanticType, checked, onChange: handleChange, value: propValue, ...restProps
}) => {
  return (
    <InputBox
      {...restProps}
      id={id}
      name={name}
      type={semanticType === 'checkbox' ? 'checkbox' : 'radio'}
      value={semanticType === 'checkbox' ? fieldValue : propValue}
      checked={semanticType === 'checkbox' ? fieldValue : checked}
      onBlur={onBlur}
      touched={get(touched, name)}
      errors={get(errors, name)}
      onChange={(event: ChangeEvent<any>) => {
        if (handleChange) {
          handleChange(event);
        }
        onChange(event);
      }}
    />
  );
};

export default InputBoxField;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/InputBoxField/InputBoxField.tsx